import React from 'react'

import { Text } from '@wartek-id/text-v1'
import { Separator } from '@wartek-id/separator'
import { Shimmer } from '@wartek-id/shimmer'

import { Header } from 'app/KinerjaShared/components/Header'
import { useAPIContentPerilakuKerja } from 'api/kinerja/useAPIKinerja'

export function DaftarPerilakuKerja() {
  // -----------------------------------------
  // Get Perilaku Kerja content
  // -----------------------------------------
  const {
    data: dataContentPerilakuKerja,
    isLoading: isLoadingContentPerilakuKerja,
  } = useAPIContentPerilakuKerja(
    {
      tipe: 'GPK',
    },
    {
      staleTime: 6 * 60 * 60 * 1000, // 6 hour
      enabled: true,
    }
  )
  const aspekList = dataContentPerilakuKerja?.data?.aspek

  return (
    <main className="max-w-7xl mx-auto py-12 px-6">
      <Header title="Daftar Perilaku Kerja" className="mb-9" />

      <div className="bg-white rounded-lg">
        {isLoadingContentPerilakuKerja ? (
          <div className="p-9 space-y-6">
            <Shimmer height="300px" width="100%" />
            <Shimmer height="300px" width="100%" />
            <Shimmer height="300px" width="100%" />
          </div>
        ) : (
          <div className="p-9">
            <div className="flex flex-col gap-10">
              {aspekList?.map((aspek, aspekIndex) => {
                return (
                  <section
                    key={aspek.id}
                    className="border border-subdued rounded p-6 space-y-6"
                  >
                    <div className="flex gap-2.5 items-start">
                      <div className="flex items-center justify-center rounded-full bg-blue-70 w-6 h-6 flex-shrink-0">
                        <Text color="inverse" variant="body-sm-bold" as="span">
                          {aspekIndex + 1}
                        </Text>
                      </div>
                      <Text variant="heading-lg" as="h2">
                        {aspek.value}
                      </Text>
                    </div>

                    {aspek.indikator.map(
                      (indikator, indikatorIndex, allIndikator) => {
                        return (
                          <React.Fragment key={`indikator-${indikator.id}`}>
                            <div className="flex flex-col gap-0.5">
                              <Text variant="body-sm" color="subdued" as="h3">
                                Indikator Perilaku
                              </Text>
                              <Text>
                                {aspekIndex + 1}.{indikatorIndex + 1}{' '}
                                {indikator.value}
                              </Text>
                            </div>

                            <div className="flex flex-col gap-0.5">
                              <Text variant="body-sm" color="subdued" as="h3">
                                Ekspektasi Khusus Pimpinan
                              </Text>
                              {indikator.ekspektasi.map(
                                (ekspektasi, ekspektasiIndex) => (
                                  <Text key={`ekspektasi-${ekspektasi.id}`}>
                                    {aspekIndex + 1}.{indikatorIndex + 1}.
                                    {ekspektasiIndex + 1} {ekspektasi.value}
                                  </Text>
                                )
                              )}
                            </div>

                            {indikatorIndex !== allIndikator.length - 1 && (
                              <Separator />
                            )}
                          </React.Fragment>
                        )
                      }
                    )}
                  </section>
                )
              })}
            </div>
          </div>
        )}
      </div>
    </main>
  )
}
